'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatApiError = function formatApiError(error, logMsg) {
  var err = (0, _get2.default)(error, 'response.data') || { message: error.message || 'unknown' };

  if (logMsg) {
    console.error(logMsg, ':', err.message);
  }

  return err;
};exports.default =

formatApiError;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/formatApiError.js
// module id = 24
// module chunks = 0